import { defineNuxtPlugin } from '#app'
import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css' // Import default Tippy styles (optional)

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueTippy, {
    // Optional default props for all tippy instances
    defaultProps: {
      arrow: true,
    },
    // Optional directive name (default is 'tippy')
    directive: 'tippy',
    // Optional component name (default is 'tippy')
    component: 'tippy',
  })
})